import { useAppSelector, userArtsApi } from "@litres-core/store";
import { useContext } from "react";
import { useGetVarioqubTestGroup } from "@litres-libs/experiments";
import { getCookie } from "@litres/utils";
import type { TMyBooksMenuItems } from "../utils/types";
import { EMyBooksRoute } from "../utils/enums";
import { myBooksRoutes } from "../constants";
import { HeaderContext } from "../Header";

import { useGetUserMonetizationData } from "./useGetUserMonetizationData";

export const useMyBooksMenuItems = (isLibrary: boolean): TMyBooksMenuItems => {
  const { isSchoolDomain, isLibraryDomain, isForeignDomain } =
    useContext(HeaderContext);

  const hasFolderArts = useAppSelector(
    state => state.foundationUser.profile.has_folder_arts
  );
  const isBonusAbTest = ["true_with_onbording", "true_no_onbording"].includes(
    useGetVarioqubTestGroup("feature_web_llt190")
  );
  const isBonusesEnabledByCookie = [
    "true_with_onbording",
    "true_no_onbording",
  ].includes(getCookie("feature_web_llt190") || "");

  const { data: statsData } = userArtsApi.useGetUserArtsStatsQuery();
  const { data: userMonetizationData } = useGetUserMonetizationData();
  const isAnon = useAppSelector(state => !state.foundationUser.id);
  const BSK = useAppSelector(state => state.foundationUser.BSK);

  const campaignsCount = userMonetizationData?.bought_collections.length;
  const inCartCount = isAnon ? BSK.length : statsData?.in_cart;

  return Object.entries(myBooksRoutes)
    .filter(
      ([id]) =>
        !(
          // исключаются пункты Библиотечные, Читаю и Слушаю и Мои акции для анонима
          (
            (isAnon &&
              (id === EMyBooksRoute.LIBRARY ||
                id === EMyBooksRoute.CAMPAIGNS ||
                id === EMyBooksRoute.READ_AND_LISTEN)) ||
            // исключается пункт Библиотечные для не библиоюзера
            (!isLibrary && id === EMyBooksRoute.LIBRARY) ||
            // исключается пункт Списки для библиоюзера
            (isLibrary && id === EMyBooksRoute.FOLDERS) ||
            // включается пункт Корзина для библиотечного + для школьников
            ((!isSchoolDomain || !isLibraryDomain) &&
              id === EMyBooksRoute.CART) ||
            // исключается пункт Мои акции если у юзера нет акции
            (id === EMyBooksRoute.CAMPAIGNS && !campaignsCount) ||
            // исключается пункт Отложено для школьников и иностранцев и вне АБ теста
            ((isSchoolDomain ||
              isForeignDomain ||
              !(isBonusAbTest || isBonusesEnabledByCookie)) &&
              id === EMyBooksRoute.LIKED)
          )
        )
    )
    .map(([href, { name, counterKey }], id) => {
      const isHasSticker = Boolean(
        (href === EMyBooksRoute.CAMPAIGNS && campaignsCount) ||
          (href === EMyBooksRoute.FOLDERS && !hasFolderArts)
      );
      const counter =
        href === EMyBooksRoute.CART
          ? inCartCount
          : (counterKey && statsData?.[counterKey]) || undefined;
      return {
        id,
        title: name,
        href,
        isHasSticker,
        counter,
      };
    });
};
